<template>
  <div>
    <div class="modal-wrapper">
      <Logo class = "with-padding-margin" />

      <div id="resetpwd-card" class = "modal-card with-border">
        <header class="modal-card-head">
          <p class="modal-card-title">¿Has olvidado tu contraseña?</p>
        </header>

        <section class="modal-card-body login-container">
          <div id="" class="" v-if="!done">
            <div class="login-forms-container ">
              <b-field label="Introduce tu dirección de email y te enviaremos un mensaje para reiniciar tu contraseña"
              :type="type_email"
              :message="msg_email">
                <b-input placeholder="Email" ref="emailField"
                    type="email"
                    icon="email" v-model="inputs.email" @keydown.native.enter="handleEnterKey" required >
                </b-input>
              </b-field>

              <div class="login-button-container" >
                <button class="btn btn-bg-colored is-fullwidth" :class="classLoading"  @click="resetPassword(inputs)" id="login-button">
                  Reestablecer contraseña
                </button>
              </div>
            </div>
          </div>
          <div v-else style="margin-top:20vh; text-align:center">
            <h2> ¡Hecho!. Mira tu buzón de email y pulsa en el link que te hemos enviado para  reestablecer tu contraseña.
              <p><router-link :to="{ name: 'Home' }">Volver a Programalaplaza</router-link> </p>
            </h2>
          </div>
        </section>
        <footer class="modal-card-foot">
          <router-link class="btn" :to="{ name: 'Home'}">Volver</router-link>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import Logo from '../UI/Logo'

export default {
  name: "ResetPassword",
  components: {
    Logo
  },
  data: () => ({
    done: false,
    inputs: {
      email: ''
    },
    msg_email:'',
    type_email:'',
    isLoading:false
  }),
  methods: {
      resetPassword ({ email }) {
        this.isLoading=true;
        if(this.ifFormValid()==false) {
          this.isLoading=false;
          return;
        }
        this.$store.dispatch('auth/resetPassword',  email )
          .then(  r => {
            this.done=true
          })
           .catch(error => {
             console.log(error.response)
             this.isLoading=false;
             this.type_email="is-danger"
             this.msg_email=error.response.data[0]
          })

        //this.$parent.close()
      },
      ifFormValid(){
        var isValid= ( this.$refs.emailField.checkHtml5Validity() )
        return (isValid)
      },
      handleEnterKey(){
        this.resetPassword(this.inputs)
        this.$refs.emailField.$el.firstElementChild.blur();
      }
  },
  computed:{
    classLoading: function(){
      if(this.isLoading==true) return 'is-loading'
      else return ''
    }
  },
  created(){
    this.$store.commit('setEditorConfigProperty', {'isShowingLogin': false})
    this.$store.commit('setEditorConfigProperty', {'isShowingRegister': false})
  }
}
</script>
<style lang="less" >
@import (reference) "../../assets/styles/main.less";

</style>



// WEBPACK FOOTER //
// src/components/Login/ResetPassword.vue